import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { FiInstagram, FiFacebook, FiTwitter, FiMail, FiPhone, FiMapPin } from 'react-icons/fi';

const Footer = () => {
  const [email, setEmail] = useState('');
  const [subscribed, setSubscribed] = useState(false);

  const handleSubscribe = (e) => {
    e.preventDefault();
    if (email) {
      setSubscribed(true);
      setEmail('');
      setTimeout(() => setSubscribed(false), 3000);
    }
  };

  return (
    <footer className="bg-primary text-white">
      {/* Newsletter Section */}
      <div className="border-b border-gray-700">
        <div className="container-custom py-12 text-center">
          <h3 className="text-2xl font-heading font-semibold mb-2">Stay in the Loop</h3>
          <p className="text-gray-400 mb-6">Subscribe for exclusive offers and new arrivals</p>
          <form onSubmit={handleSubscribe} className="max-w-md mx-auto flex gap-2">
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="Enter your email"
              className="flex-1 px-4 py-3 rounded-md bg-gray-800 border border-gray-700 text-white placeholder-gray-500 focus:outline-none focus:border-accent"
              required
            />
            <button type="submit" className="btn-accent whitespace-nowrap">
              {subscribed ? 'Subscribed!' : 'Subscribe'}
            </button>
          </form>
        </div>
      </div>

      {/* Main Footer */}
      <div className="container-custom py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* Brand */}
          <div>
            <h2 className="text-xl font-heading font-bold mb-4">
              indi.<span className="text-accent">sisters</span>
            </h2>
            <p className="text-gray-400 text-sm leading-relaxed mb-4">
              Celebrating Indian craftsmanship with contemporary fashion. Handcrafted pieces that tell a story of tradition meeting modernity.
            </p>
            <div className="flex space-x-4">
              <a href="https://www.instagram.com/indi.sisters" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-accent transition-colors">
                <FiInstagram size={20} />
              </a>
              <a href="#" className="text-gray-400 hover:text-accent transition-colors">
                <FiFacebook size={20} />
              </a>
              <a href="#" className="text-gray-400 hover:text-accent transition-colors">
                <FiTwitter size={20} />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-semibold mb-4">Quick Links</h4>
            <ul className="space-y-2 text-sm text-gray-400">
              <li><Link to="/shop" className="hover:text-accent transition-colors">Shop All</Link></li>
              <li><Link to="/category/new-arrivals" className="hover:text-accent transition-colors">New Arrivals</Link></li>
              <li><Link to="/category/sale" className="hover:text-accent transition-colors">Sale</Link></li>
              <li><Link to="/categories" className="hover:text-accent transition-colors">Categories</Link></li>
              <li><Link to="/wishlist" className="hover:text-accent transition-colors">Wishlist</Link></li>
            </ul>
          </div>

          {/* Customer Service */}
          <div>
            <h4 className="font-semibold mb-4">Customer Service</h4>
            <ul className="space-y-2 text-sm text-gray-400">
              <li><a href="#" className="hover:text-accent transition-colors">About Us</a></li>
              <li><a href="#" className="hover:text-accent transition-colors">Contact Us</a></li>
              <li><a href="#" className="hover:text-accent transition-colors">Shipping & Returns</a></li>
              <li><a href="#" className="hover:text-accent transition-colors">Privacy Policy</a></li>
              <li><a href="#" className="hover:text-accent transition-colors">Terms & Conditions</a></li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="font-semibold mb-4">Get in Touch</h4>
            <ul className="space-y-3 text-sm text-gray-400">
              <li className="flex items-center gap-2">
                <FiMail size={16} />
                <span>radhika.indisisters@gmail.com</span>
              </li>
              <li className="flex items-center gap-2">
                <FiPhone size={16} />
                <span>+91 96878 05555</span>
              </li>
              <li className="flex items-start gap-2">
                <FiMapPin size={16} className="mt-0.5" />
                <span>Rajkot, Gujarat, India</span>
              </li>
            </ul>
          </div>
        </div>
      </div>

      {/* Copyright */}
      <div className="border-t border-gray-700">
        <div className="container-custom py-4 text-center text-sm text-gray-500">
          <p>&copy; {new Date().getFullYear()} IndiSisters. All rights reserved. Handcrafted with love in India.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
